export default __webpack_public_path__ + "static/media/e10.3457b6d5.jpg";